import * as React from 'react';
import { Table, Avatar } from 'antd';
import { Offer, Boost } from 'src/store';
import { Subscription } from 'rxjs';
import * as firebase from 'firebase/app';
import { ColumnProps } from 'antd/lib/table';
import { DisplayDate } from 'src/components';

interface Props {
    merchantId?: string | null;
}

interface S {
    data: Boost[];
    loading?: boolean;
    currentPage: number;
}

class BoostList extends React.Component<Props, S> {
    subscription: Subscription;
    columns: ColumnProps<Boost>[];
    pageSize: number;
    constructor(props: Props) {
        super(props);

        this.subscription = new Subscription();
        this.pageSize = 10;
        this.state = { data: [], loading: false, currentPage: 1 };

    }

    componentDidMount() {
        this.getData();
    }

    getData = async () => {
        this.setState({ loading: true });
        const { merchantId } = this.props;
        const data = [] as Boost[];
        const boostQueryRef = firebase.firestore()
            .doc(`merchants/${merchantId}`)
            .collection('boosts')
            .orderBy('createdAt', 'desc');
        const boostSnapshot = await boostQueryRef.get();
        if (!boostSnapshot.empty) {
            for (const doc of boostSnapshot.docs) {
                const boost = doc.data() as Boost;
                const offerDoc = await firebase.firestore()
                    .doc(`merchants/${merchantId}/offers/${boost.offerId}`).get();
                const offer = offerDoc.data() as Offer;
                boost.offer = offer;
                data.push(boost);
            }
            this.setState({ data, loading: false, });
        } else {
            this.setState({ data: [], loading: false });
        }

    }

    componentWillUnmount() {
        this.subscription.unsubscribe();
    }

    getDataSource = () => {
        const { data, loading, currentPage } = this.state;
        const page = loading ? 1 : currentPage;
        const ds = !loading ?
            data.map((obj, i) => ({
                no: ((page - 1) * this.pageSize) + (i + 1),
                key: obj.id,
                ...obj,
            })) : [];

        return {
            ds,
            page,
        };
    }
    render() {
        const { ds } = this.getDataSource();
        const { loading } = this.state;
        this.columns = [{
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            width: "5%",
            render: (text: string, record: Boost, index: number) => {
                return <span>{record.no}</span>;
            }
        },
        {
            title: 'Image',
            dataIndex: 'imageName',
            key: 'imageName',
            width: "10%",
            // tslint:disable-next-line:no-any
            render: (text: string, record: Boost) => (
                <span>
                    <Avatar
                        src={record.offer.photo}
                        className="img-card"
                    />
                </span>
            )
        },
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            width: '20%',
            render: (text: string, record: Boost, index: number) => {
                return <span>{record.offer.name}</span>;
            }
        },
        {
            title: 'Budget',
            dataIndex: 'budget',
            key: 'budget',
            width: '20%',
        },
        {
            title: 'Fail Count',
            dataIndex: 'totalFailureCount',
            key: 'totalFailureCount',
            width: '15%',
        },
        {
            title: 'Success Count',
            dataIndex: 'totalSuccessCount',
            key: 'totalSuccessCount',
            width: '15%',
        },
        {
            title: 'Created At',
            dataIndex: 'createdAt',
            width: '15%',
            // tslint:disable-next-line:no-any
            render: (text: string, record: any) => {
                return <DisplayDate dateTime={record.createdAt.toDate()} />
            }
        },
            // {
            //     title: 'Signed In',
            //     dataIndex: 'creat',
            //     key: 'loginUserName',
            //     width: '15%',
            //     // tslint:disable-next-line:no-any
            //     render: (text: string, record: any) => {
            //         return <DisplayDate dateTime={record.metadata.lastSignInTime} />
            //     }
            // }
        ];
        return (
            <Table
                loading={loading}
                columns={this.columns}
                dataSource={ds}
                // onRow={this.handleOnRow}
                pagination={{
                    // current: page || 0,
                    // pageSize: this.pageSize,
                    // total: ds.length || 0,
                    // onChange: this.handlePageChange,
                    showTotal: (total) => <span className="total-count">Total Count: {total}</span>
                }}
                size="middle"
                bordered={true}
            />
        );
    }
}

export default BoostList;



// WEBPACK FOOTER //
// ./src/merchants/forms/Boosts.tsx